/* eslint-disable no-nested-ternary */
import { Box, Link } from '@material-ui/core';
import { getPlaceholders } from 'constants/text/placeholders';
import { ProficiencyDisplay } from './ProficiencyDisplay';
import SvgIconStyle from './SvgIconStyle';

const isLink = (val: string) =>
  val.includes('http://') || val.includes('https://');

const CardField = ({ label, value, proficiency, component, iconSrc, recruiterOrAdmin, withoutBox }: any) => {
  const { NOT_INDICATED } = getPlaceholders();
  return (
    <Box
      style={{
        margin: '5px 0',
        fontFamily: 'Rubik',
        color: '#131417',
        display: 'flex',
        fontSize: '18px'
      }}
    >
      {iconSrc && (
        <SvgIconStyle src={iconSrc} style={{ ...(withoutBox ? { margin: '10px 10px 0 0' } : { marginRight: '10px' }) }} onClick={() => { if (recruiterOrAdmin) window.open(`mailto:${value}`) }} />
      )}
      <Box component="span" style={{ ...(withoutBox ? { whiteSpace: 'nowrap', fontWeight: 600, color: '#562C82', fontSize: '18px' } : { fontWeight: 600, color: '#562C82', fontSize: '18px' }) }}>
        {label ? `${label}:` : ''}
      </Box>
      &nbsp;
      <Box component="span">
        {proficiency ? (
          <ProficiencyDisplay proficiency={value} withoutBox={withoutBox} />
        ) : value?.length ? (
          isLink(value) ? (
            <Link href={value} target="blank">
              {value}
            </Link>
          ) : (
            value
          )
        ) : (
          NOT_INDICATED
        )}
        {component || null}
      </Box>
    </Box>
  );
};

export default CardField;
